/**
 * Public self-signup is ENABLED with a 15-Day Free All-Access Evaluation Trial.
 * New jewellery businesses can register and evaluate ERP features immediately.
 */
export const PUBLIC_SELF_SIGNUP_DISABLED = false;

export const DEFAULT_PUBLIC_TRIAL_DAYS = 15;

export const PUBLIC_SIGNUP_PATH = "/signup" as const;
export const REQUEST_ACCESS_PATH = "/signup" as const;

/** Trial URL — routes to the public signup page. */
export const LEGACY_TRIAL_PATH = "/signup" as const;

export function trialSignupHeadline(): string {
  return `${DEFAULT_PUBLIC_TRIAL_DAYS}-Day Free Trial`;
}
